import React, { useEffect, useState } from "react";
import { Modal, Table } from "../../../../onestep-library/BaseUI";
import { useSelector, useDispatch } from "react-redux";
import AvailableFundsListing from "./components/AvailableFundsListing";

export default function AvailableFundsHistory(props) {
  const dispatch = useDispatch();
  const [transactions, setTransactions] = useState([]);
  const { availableFundsHistory, organization, resident } = useSelector(
    (state) => state
  );
  const { ui, errors = [] } = availableFundsHistory;
  const { show } = ui;

  useEffect(() => {
    if (show) {
      $.ajax({
        url: `/organizations/${organization.name}/residents/${resident.id}/available_funds_history.json`,
        success: (response) => setTransactions(response),
      });
    }
  }, [show]);

  function onClose() {
    dispatch({
      type: "UPDATE_AVAILABLE_FUNDS_HISTORY_UI",
      payload: { show: false },
    });
  }

  return (
    <Modal
      show={show}
      title="Available Funds History"
      handleClose={onClose}
      size="lg"
    >
      <Table
        columnNames={[`Submitted On`, "Payment Method", "Memo", "Amount", "Receipt Sent", "" , ""]}
        rows={transactions}
        Row={AvailableFundsListing}
        zeroCaseMessage="No Available Funds History"
      />
      <div className="d-flex justify-content-end">
        <div className="btn btn-sm btn-primary" onClick={onClose}>
          Close
        </div>
      </div>
    </Modal>
  );
}
